import { createContext, useContext } from 'react';

export interface Me {
  admin: { id: string; email: string; name: string; role: string; permissions: string[] };
  org: { id: string; name: string; slug: string };
  csrfToken: string;
}
export const MeCtx = createContext<Me | null>(null);
export const useMe = () => useContext(MeCtx)!;
export const useCan = () => {
  const me = useMe();
  return (p: string) => me.admin.permissions.includes(p);
};

export function BrandMark() {
  return (
    <svg className="brand-mark" viewBox="0 0 22 22" aria-hidden="true">
      <path d="M11 1.5 3 4.6v6.1c0 4.7 3.3 8.7 8 9.8 4.7-1.1 8-5.1 8-9.8V4.6L11 1.5Z" fill="var(--ink)" />
      <path d="M7 11.2 9.7 14 15 8" fill="none" stroke="var(--paper)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/** Brand header on the signed-out screens (sign-in, invitation). */
export function ConsoleBrand() {
  return <div className="brand"><BrandMark /><div><b>Ward</b><small>Browser security console</small></div></div>;
}
